import React from "react";
import Header from "../../UserManagement/Components/Header";

const AccessPlansTab = () => {
  return (
    <div>
      <div>
        <Header
          title={"Access Plans"}
          // subTitle={"Product revenue, platform fees, and commission tracking"}
        />
      </div>
    </div>
  );
};

export default AccessPlansTab;
